import { Badge, Group, Stack, Text } from '@mantine/core'
import type { FinalAssessmentItem } from '../types'

/**
 * Final-assessment curriculum header: the Lv1 badge (green for content, blue
 * for skills) plus the bold code and item name. The legacy final payload has
 * no pre-built breadcrumb, so we render the fields it does provide
 * (`lv1Name`, `originalCodes`, `name`) — matching the prototype's row.
 */
export function FinalCurriculumRow({ item }: { item: FinalAssessmentItem }) {
  const color = item.curriculumKind === 'content' ? 'green' : 'blue'
  return (
    <Stack spacing={4}>
      <Group spacing={4} align="center">
        <Badge size="md" color={color} variant="light" style={{ textTransform: 'uppercase' }}>
          {item.lv1Name}
        </Badge>
      </Group>
      <Text size="sm">
        {item.originalCodes ? (
          <>
            <Text span weight={700}>
              {item.originalCodes}
            </Text>
            {' - '}
            {item.name}
          </>
        ) : (
          item.name
        )}
      </Text>
    </Stack>
  )
}
